import LocalizationConstants from "../constants/localization-constants";
import { ViewType } from "./Enums";

export class ToolGridView {
  value = ViewType.ToolsAll;
  label = LocalizationConstants.MY_TOOLS_PAGE_TITLE;
}
